import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { statesConst } from "_constants";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  margin-top: 33px;
  margin-bottom: 33px;
`;
const Title = styled.h1`
  width: 100%;
  font-weight: bold;
  font-size: 18px;
  line-height: 47px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 16px;
    `}
`;
const OwnerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 100%;
  max-width: 100%;
`;
const Group = styled.div`
  min-width: 33%;
  padding: 10px;
`;
const Label = styled.div`
  font-weight: normal;
  font-size: 14px;
  color: #7b848d;
`;
const Data = styled(Label)`
  font-weight: bold;
`;
const Address = styled(Group)`
  min-width: 100%;
`;

function Owner({ index, partyName, partyType, legalEntityTypeCode, address1, city, state, postcode }) {
  const title = () => {
    switch (index) {
      case 0:
        return <Title>Current Trademark Owners</Title>;
      case 1:
        return <Title>Trademark Owner History</Title>;
      default:
        return null;
    }
  };

  return (
    <OwnerContainer>
      {title()}
      <Group>
        <Label>Party name</Label>
        <Data>{partyName}</Data>
      </Group>

      <Group>
        <Label>Party type</Label>
        <Data>{partyType}</Data>
      </Group>

      <Group>
        <Label>Legal entity type</Label>
        <Data>{legalEntityTypeCode}</Data>
      </Group>
      <Address>
        <Label>Address</Label>
        <Data>{`${address1}, ${city}, ${statesConst[state]}, ${postcode}`}</Data>
      </Address>
    </OwnerContainer>
  );
}

Owner.propTypes = {
  index: PropTypes.number,
  partyName: PropTypes.string,
  partyType: PropTypes.string,
  legalEntityTypeCode: PropTypes.string,
  address1: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postcode: PropTypes.string,
};

function OwnerList({ owners }) {
  return (
    <Container>
      {owners && owners.length === 0 ? (
        <Title>No Owners</Title>
      ) : (
        owners.map((ownerInfo, idx) => <Owner key={idx} index={idx} {...ownerInfo} />)
      )}
    </Container>
  );
}

OwnerList.propTypes = {
  owners: PropTypes.arrayOf(PropTypes.object),
};

export default OwnerList;
